import type React from "react";
import type { AuditLogEntry } from "../types/index.js";

interface AuditLogFeedProps {
  logs: AuditLogEntry[];
}

export const AuditLogFeed: React.FC<AuditLogFeedProps> = ({ logs }) => {
  return (
    <div style={{ padding: "24px" }}>
      <div style={{ marginBottom: "16px" }}>
        <h2 style={{ margin: 0, fontSize: "16px", color: "#f8fafc" }}>
          Control Plane Audit Stream
        </h2>
        <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#64748b" }}>
          Immutable ledger of all administrative lifecycle, provisioning, and status mutations.
        </p>
      </div>

      <div
        style={{
          backgroundColor: "#0f172a",
          border: "1px solid #1e293b",
          borderRadius: "8px",
          padding: "16px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {logs.map((log) => (
            <div
              key={log.id}
              style={{
                padding: "12px 16px",
                backgroundColor: "#1e293b",
                borderRadius: "6px",
                borderLeft: "4px solid #38bdf8",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "13px",
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontWeight: 700, color: "#f8fafc" }}>
                    {log.action}
                  </span>
                  {log.tenantId && (
                    <code style={{ fontSize: "11px", color: "#94a3b8" }}>
                      tenant: {log.tenantId.slice(0, 8)}...
                    </code>
                  )}
                </div>
                {log.detailJson && (
                  <div
                    style={{
                      marginTop: "4px",
                      fontSize: "11px",
                      color: "#94a3b8",
                      fontFamily: "monospace",
                    }}
                  >
                    {log.detailJson}
                  </div>
                )}
              </div>

              <div style={{ textAlign: "right", fontSize: "11px", color: "#64748b" }}>
                <div>{new Date(log.createdAt).toLocaleTimeString()}</div>
                <div>{new Date(log.createdAt).toLocaleDateString()}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
